import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useOktaAuth } from "@okta/okta-react";
import UserProfile from "../Components/UserProfile";

const Profile = () => {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    async function authenticate() {
      if (!authState) return;

      if (!authState.isAuthenticated) {
        await oktaAuth.signInWithRedirect();
      }
    }

    authenticate();
  }, [authState, oktaAuth]);

  if (!authState?.isAuthenticated) {
    return (
      <Container>
        <p>Please wait while we sign you in</p>
      </Container>
    );
  } else {
    return (
      <Container>
        <UserProfile/>
      </Container>
    );
  }
};

export default Profile;